import Vue from "vue";
import Toasted from "vue-toasted";
import i18n from "@/utils/i18n";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import App from "./App.vue";
import store from "./store/store";
import router from "./route/index";
import "./registerServiceWorker";
import "./assets/css/style.css";
import { SessionHelper, X_AUTH_ID } from "./utils/session"

Sentry.init({
  dsn:
    "https://205e1088cae240e9b7b3101f6d5769c7@sentry.services-money91.com/16",
  integrations: [new Integrations.Vue({ Vue, attachProps: true })]
});

Sentry.setUser({ id: SessionHelper.getCookie(X_AUTH_ID) });

window._JWT = {};
window.__native_money91 = {}
Vue.config.productionTip = false;


Vue.use(Toasted, {
  theme: "toasted-primary",
  duration: 2000
});
Vue.use(window.ads91);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
